import { Link } from "react-router-dom";
import { useState, useRef, useEffect, useContext } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import "react-toastify/dist/ReactToastify.css";
import service from "../services/authservices";
import Tab from "react-bootstrap/Tab";
import { ScaleLoader } from "react-spinners";
import Tabs from "react-bootstrap/Tabs";
import { toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import authService from "../services/authservices";
import dayjs from "dayjs";
import { getUserDetails } from "../services/authservices";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

const HistoryAll = () => {
  const [supportHistory, setSupportHistory] = useState([]);
  const [adminrewadHistory, setAdminrewadHistory] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [withdrawalHistory, setWithdrawalHistory] = useState([]);
  const [loader, setLoader] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [loginHistory, setLoginHistory] = useState([]);
  const [withdrawaddress, setWithdrawAddress] = useState([]);
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);

  const [getpool, setGetpool] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPageWd, setCurrentPageWd] = useState(1);
  const [totalPagesWd, setTotalPagesWd] = useState(0);
  const [limitWd, setLimitWd] = useState(10);
  const [currentPageDp, setCurrentPageDp] = useState(1);
  const [totalPagesDp, setTotalPagesDp] = useState(0);
  const [limitDp, setLimitDp] = useState(10);
  const [currentPageSp, setCurrentPageSp] = useState(1);
  const [totalPagesSp, setTotalPagesSp] = useState(0);
  const [limitSp, setLimitSp] = useState(10);
  const [currency, setCurrency] = useState("usdt");
  const [network, setNetwork] = useState("BEP20");
  const [addressData, setAddressData] = useState(null);
  const [currentPageCp, setCurrentPageCp] = useState(1);
  const [totalPagesCp, setTotalPagesCp] = useState(0);
  const [limitCp, setLimitCp] = useState(10);
  const [referralHistory, setReferralHistory] = useState([]);
  const [bottradeHistory, setbottradeHistory] = useState([]);
  const [planHistory, setplanHistory] = useState([]);
  const [currentPageRef, setCurrentPageRef] = useState(1);
  const [totalPagesRef, setTotalPagesRef] = useState(0);
  const [limitRef, setLimitRef] = useState(10);
  const [currentPagewithadd, setCurrentPagewithadd] = useState(1);
  const [totalPageswithadd, setTotalPageswithadd] = useState(0);
  const [limitwithadd, setLimitwithadd] = useState(10);
  const [currentPagebtrade, setCurrentPagebtrade] = useState(1);
  const [totalPagesbtrade, setTotalPagesbtrade] = useState(0);
  const [limitbtrade, setLimitbtrade] = useState(10);
  const [currentPageplans, setCurrentPageplans] = useState(1);
  const [totalPagesplans, setTotalPagesplans] = useState(0);
  const [limitplans, setLimitbtradeplans] = useState(10);
  const [currentPageadrew, setCurrentadrew] = useState(1);
  const [totalPagesadrew, setTotalPagesadrew] = useState(0);
  const [limitadrew, setLimitadrew] = useState(10);
  const [NotifyHistory, setNotifyHistory] = useState([]);
  const [notifycurrentPage, setnotifyCurrentPage] = useState(1);
  const [notifytotalPages, setnotifyTotalPages] = useState(0);
  const [limitnotify, setLimitnotify] = useState(10);
  const [buycryptoHistory, setbuycryptHistory] = useState([]);
  const [buycryptcurrentPage, setbuycryptCurrentPage] = useState(1);
  const [buycrypttotalPages, setbuycryptTotalPages] = useState(0);
  const [limitbuycrypt, setLimitbuycrypt] = useState(10);

  const [loading, setLoading] = useState(true);
  const coinTyperef = useRef(currency);
  useEffect(() => {
    fetchSupportHistory(currentPageSp, limitSp);
    getPool(currentPageCp, limitCp);
    fetchLoginHistory(currentPage, limit);
    fetchWithdrawalHistory(currentPageWd, limitWd);
    fetchTransactions(currentPageDp, limitDp);
    fetchReferralHistory(currentPageRef, limitRef);
    fetchWithdrawalAddress(currentPagewithadd, limitwithadd);
    fetchbottradeHistory(currentPagebtrade, limitbtrade);
    fetchplansHistory(currentPageplans, limitplans);
    fetchadminrewardHistory(currentPageadrew, limitadrew);
    fetchNotification(notifycurrentPage, limitnotify);
    fetchBuycrypto(buycryptcurrentPage, limitbuycrypt);
  }, [
    currentPageSp,
    limitSp,
    currentPageCp,
    limitCp,
    currentPage,
    limit,
    currentPageWd,
    limitWd,
    currentPageDp,
    limitDp,
    currentPageRef,
    limitRef,
    currentPagewithadd,
    limitwithadd,
    currentPagebtrade,
    limitbtrade,
    currentPageplans,
    limitplans,
    currentPageadrew,
    limitadrew,
    notifycurrentPage,
    limitnotify,
    buycryptcurrentPage,
    limitbuycrypt,
  ]);

  const handleSoftDelete = async (addressId) => {
    setWithdrawAddress((prev) =>
      prev.filter((address) => address._id !== addressId)
    );
    const data = {
      addressId: addressId,
    };
    const response = await service.softDeleteAddress(data);
    if (response.status) {
      showSuccessToast(response.message);
    } else {
      showErrorToast(response.message);
    }
  };

  const truncateText = (text, maxLength) => {
    if (!text || typeof text !== "string") {
      return "--";
    }
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + " . . .";
    }
    return text;
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const handlePageChange = (event, value, eventName) => {
    switch (eventName) {
      case "Login":
        setCurrentPage(value);
        break;
      case "Withdraw":
        setCurrentPageWd(value);
        break;
      case "Deposit":
        setCurrentPageDp(value);
        break;
      case "Support":
        setCurrentPageSp(value);
        break;
      case "Collective Sharing":
        setCurrentPageCp(value);
        break;
      case "Referral":
        setCurrentPageRef(value);
        break;
      case "Withdraw Address":
        setCurrentPagewithadd(value);
        break;
      case "Bot Trade":
        setCurrentPagebtrade(value);
        break;
      case "Plans":
        setCurrentPageplans(value);
        break;
      case "Rewards":
        setCurrentadrew(value);
        break;
      case "notification":
        setnotifyCurrentPage(value);
        break;

      default:
        break;
    }
  };

  const handleCopy = (txID) => {
    if (handleCopy.toastVisible) return;

    handleCopy.toastVisible = true;

    if (handleCopy.timeout) clearTimeout(handleCopy.timeout);

    handleCopy.timeout = setTimeout(() => {
      navigator.clipboard
        .writeText(txID)
        .then(() => {
          toast.success(
            <div className="toast-ml">
              <h4 className="toast-title">Success!</h4>
              <p className="toast-message">
                Transaction ID copied to clipboard!
              </p>
            </div>
          );
        })
        .catch((err) => {
          // console.error("Failed to copy text: ", err);
          toast.error(
            <div className="toast-ml">
              <h4 className="toast-title">Error!</h4>
              <p className="toast-message">Failed to copy Transaction ID</p>
            </div>
          );
        })
        .finally(() => {
          setTimeout(() => {
            handleCopy.toastVisible = false;
          }, 2000);
        });
    }, 300); // 300ms debounce time
  };

  const fetchReferralHistory = async (page, limit) => {
    try {
      setLoader(true);

      const data = await service.getReferralHistory(page, limit);

      if (data && data.status && Array.isArray(data.referralHistory)) {
        // console.log(data.referralHistory, "Referral History");

        setReferralHistory(data.referralHistory);
        setTotalPagesRef(Math.ceil(data.total / limit));
      } else {
        setReferralHistory([]);
      }
    } catch (error) {
      console.error("Error fetching referral history:", error);

      setReferralHistory([]);
    } finally {
      setLoader(false);
    }
  };

  const fetchUserDetails = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        setLoader(true);
        const data = await getUserDetails(token);
        if (data && data.status) {
          setLoader(false);
        } else {
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);
      }
    } else {
      setLoader(false);
    }
    setLoading(false);
  };

  const getPool = async (page, limit) => {
    try {
      setLoader(true);
      const response = await service.getPool(page, limit);
      setLoader(false);
      if (response.status) {
        setGetpool(response.data);
        setTotalPagesCp(Math.ceil(response.total / limit));
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  const fetchLoginHistory = async (page, limit) => {
    try {
      setLoader(true);
      const response = await service.getLoginHistory(page, limit);
      if (response.status) {
        setLoginHistory(response.data);
        setTotalPages(Math.ceil(response.total / limit));
        setLoader(false);
      } else {
        console.error("Failed to fetch login history:", response.Message);
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching login history:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const fetchWithdrawalHistory = async (page, limit) => {
    setLoader(true);
    const response = await service.getWithdrawalHistory(page, limit);
    if (response.status) {
      setWithdrawalHistory(response.data);
      setTotalPagesWd(Math.ceil(response.total / limit));
      setLoader(false);
    } else {
      console.error("Failed to fetch withdrawal history:", response.Message);
      setLoader(false);
    }
  };
  const fetchbottradeHistory = async (page, limit) => {
    setLoader(true);
    const response = await service.getBottradeHistory(page, limit);
    if (response.status) {
      setbottradeHistory(response.data);
      setTotalPagesbtrade(Math.ceil(response.total / limit));
      setLoader(false);
    } else {
      console.error("Failed to fetch bot history:", response.Message);
      setLoader(false);
    }
  };

  const fetchplansHistory = async (page, limit) => {
    setLoader(true);
    const response = await service.getPlanDetailsById(page, limit);
    if (response.status) {
      setplanHistory(response.data);
      setTotalPagesplans(Math.ceil(response.total / limit));
      setLoader(false);
    } else {
      console.error("Failed to fetch history:", response.Message);
      setLoader(false);
    }
  };

  const fetchWithdrawalAddress = async (page, limit) => {
    setLoader(true);
    const response = await service.getWithdrawAddress(page, limit);
    // console.log(response, "withdrawaddress");
    if (response.status) {
      // console.log(response.data, "withdrawaddress");
      setWithdrawAddress(response.data);
      setTotalPageswithadd(Math.ceil(response.total / limit));
      setLoader(false);
      // console.log(withdrawaddress, "withdrawaddress");
    } else {
      console.error("Failed to fetch withdrawal Address:", response.Message);
      setLoader(false);
    }
  };

  const [supportdata, setsupportdata] = useState({});
  const [open, setOpen] = useState(false);

  const fetchSupportHistory = async (page, limit) => {
    try {
      setLoader(true);
      const response = await service.getsupport(page, limit);
      if (response.status) {
        setSupportHistory(response.data);
        setTotalPagesSp(Math.ceil(response.total / limit));
        setLoader(false);
      } else {
        console.error("Failed to fetch support history");
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error fetching support history:", error);
    }
  };
  const handleOpen = (data) => {
    setOpen(true);
    setsupportdata(data ? data : "");
    // console.log("data-->>", supportdata);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const fetchadminrewardHistory = async (page, limit) => {
    try {
      setLoader(true);
      const response = await service.getCombinedRewardHistory(page, limit);
      if (response.status) {
        setAdminrewadHistory(response.data);
        setTotalPagesadrew(Math.ceil(response.total / limit));
        setLoader(false);
      } else {
        console.error("Failed to fetch support history");
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error fetching support history:", error);
    }
  };

  const fetchNotification = async (page, limit) => {
    setLoader(true);
    try {
      const response = await service.getNotificationHistory(page, limit);
      if (response.status) {
        setNotifyHistory(response.data);
        // console.log(response.data, "response.data-response.data");
        setnotifyTotalPages(Math.ceil(response.total / limit));
        setLoader(false);
      } else {
        console.error(
          "Failed to fetch Notification history:",
          response.Message
        );
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching Notification history:", error);
    } finally {
      setLoader(false);
    }
  };
  const fetchBuycrypto = async (page, limit) => {
    setLoader(true);
    try {
      const response = await service.getBuycryptoHistory(page, limit);
      if (response.status) {
        setbuycryptHistory(response.data);
        setbuycryptTotalPages(Math.ceil(response.total / limit));
        setLoader(false);
      } else {
        console.error(
          "Failed to fetch Notification history:",
          response.Message
        );
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching Notification history:", error);
    } finally {
      setLoader(false);
    }
  };

  const showErrorToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true); // Set toast as visible
      toast.error(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset toastVisible on close
          autoClose: 3000, // Optional: auto-close after 3 seconds
        }
      );
    }
  };

  const showSuccessToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.success(
        <div className="toast-ml">
          <h4 className="toast-title">Success!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset state on close
          autoClose: 3000, // Auto-close after 3 seconds
        }
      );
    }
  };

  const fetchTransactions = async () => {
    setLoading(true);
    try {
      const response = await service.getDepositHistory();
      if (response.status) {
        if (Array.isArray(response.data) && response.data.length > 0) {
          // Filter unique transactions based on transactionId
          const uniqueTransactions = response.data.filter(
            (value, index, self) =>
              index ===
              self.findIndex((t) => t.transactionId === value.transactionId)
          );
          setTransactions(uniqueTransactions);
        } else {
          setTransactions([]);
        }
      } else {
        setTransactions([]);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
      setTransactions([]);
      showErrorToast("Failed to load transactions");
    } finally {
      setLoading(false);
    }
  };

  const handleClickmethod = () => {
    console.log("onclick");
  };
  return (
    <>
      <section>
        <Header />
      </section>

      <div className="withdraw-section">
        <div className="container">
          <div className="row prof_row_sm">
            <div className="col-lg-3 dispaly_none_1200">
              <Sidebar />
            </div>

            <div className="col-xl-9 col-lg-12 deposit_pad_top">
              <span className="profile_span">{t("History")}</span>
              <div className="col-md-12 col-lg-12 verfication_kyc_col">
                <div className="pad-l-r">
                  <section className="asset_section">
                    <>
                      <>
                        <Tabs
                          defaultActiveKey="home"
                          id="uncontrolled-tab-example"
                          className="deposit_accounthead"
                          onClick={handleClickmethod}
                        >
                          <Tab eventKey="home" title={t("Login")}>
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="secuirty_box">
                                  <div className="secuirty_box_contentsub deposit_contentsub">
                                    <div className="table_section home_recent_table">
                                      <div className="table_boxcontainer">
                                        <table>
                                          <thead>
                                            <tr>
                                              <th>{t("IPAddress")}</th>
                                              <th>{t("Date&Time")}</th>
                                              <th>{t("OS")}</th>
                                              <th>{t("Device")}</th>
                                              <th>{t("Browser")}</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {loader ? (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                    padding: "20px",
                                                  }}
                                                >
                                                  <div className="loader_main loader_mainChange">
                                                    <ScaleLoader
                                                      color="#20A1FD"
                                                      height={10}
                                                      width={3}
                                                    />
                                                    <p>{t("Loading")}</p>
                                                  </div>
                                                </td>
                                              </tr>
                                            ) : loginHistory.length > 0 ? (
                                              loginHistory.map(
                                                (login, index) => (
                                                  <tr key={index}>
                                                    <td className="table-flex">
                                                      <span>
                                                        {login.ipAddress}
                                                      </span>
                                                    </td>
                                                    <td>
                                                      {" "}
                                                      <span>
                                                        {isNaN(
                                                          new Date(
                                                            login.createdTime
                                                          )
                                                        )
                                                          ? "null"
                                                          : dayjs(
                                                              login.createdTime
                                                            ).format(
                                                              "DD MMMM YYYY, hh:mm A"
                                                            )}
                                                      </span>
                                                    </td>
                                                    <td className="table-flex">
                                                      {" "}
                                                      <span>
                                                        {login.os || "N/A"}
                                                      </span>
                                                    </td>
                                                    <td>
                                                      {" "}
                                                      <span>
                                                        {login.device || "N/A"}
                                                      </span>
                                                    </td>
                                                    <td>
                                                      <span>
                                                        {login.browser || "N/A"}
                                                      </span>
                                                    </td>
                                                  </tr>
                                                )
                                              )
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <span className="depo_no_record">
                                                    {t("Nologin")}
                                                  </span>
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                        {totalPages > 1 && (
                                          <div className="pagination history_pagination_all ">
                                            <Stack spacing={2}>
                                              <Pagination
                                                count={totalPages}
                                                page={currentPage}
                                                onChange={(e, value) =>
                                                  handlePageChange(
                                                    e,
                                                    value,
                                                    "Login"
                                                  )
                                                }
                                                size="small"
                                                sx={{
                                                  "& .MuiPaginationItem-root": {
                                                    color: "#fff",
                                                  },
                                                  "& .Mui-selected": {
                                                    backgroundColor:
                                                      "#ffc630 !important",
                                                    color: "#000",
                                                    "&:hover": {
                                                      backgroundColor:
                                                        "#ffc630",
                                                      color: "#000",
                                                    },
                                                  },
                                                  "& .MuiPaginationItem-ellipsis":
                                                    {
                                                      color: "#fff",
                                                    },
                                                  "& .MuiPaginationItem-icon": {
                                                    color: "#fff",
                                                  },
                                                }}
                                              />
                                            </Stack>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Tab>
                          <Tab eventKey="profile" title={t("Deposit")}>
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="secuirty_box">
                                  <div className="secuirty_box_contentsub deposit_contentsub">
                                    <div className="table_section home_recent_table">
                                      <div
                                        className="table_boxcontainer"
                                        style={{ height: "max-content" }}
                                      >
                                        <table>
                                          <thead>
                                            <tr>
                                              <th className="text_left">
                                                {t("Currency")}
                                              </th>
                                              <th>{t("Date&Time")}</th>
                                              <th>{t("Network")}</th>
                                              <th>{t("Amount")}</th>
                                              <th>{t("TransactionID")}</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {transactions.length > 0 ? (
                                              transactions
                                                .slice(0, 5)
                                                .map((transaction, index) => (
                                                  <tr key={index}>
                                                    <td>
                                                      <div className="home_recent_firstdata">
                                                        <img
                                                          src={
                                                            transaction.currency ===
                                                            "usdt"
                                                              ? require("../assests/usdt-logo.png")
                                                              : transaction.currency ===
                                                                "usdt"
                                                              ? require("../assests/usdt-logo.png")
                                                              : require("../assests/usdt-logo.png")
                                                          }
                                                          alt={
                                                            transaction.currency
                                                          }
                                                          className="usdt_home_recent"
                                                        />
                                                        <span>
                                                          {transaction.currency}
                                                        </span>
                                                      </div>
                                                    </td>
                                                    <td>
                                                      <span>
                                                        {isNaN(
                                                          new Date(
                                                            transaction.date
                                                          )
                                                        )
                                                          ? "null"
                                                          : dayjs(
                                                              transaction.date
                                                            ).format(
                                                              "DD MMMM YYYY, hh:mm A"
                                                            )}
                                                      </span>
                                                    </td>
                                                    <td>
                                                      <span>
                                                        {transaction.network}
                                                      </span>
                                                    </td>
                                                    <td>
                                                      <span>
                                                        {transaction.amount}
                                                      </span>
                                                    </td>
                                                    <td>
                                                      <div className="home_uid_main">
                                                        <span>
                                                          {
                                                            transaction.transactionId
                                                          }
                                                        </span>
                                                        <i
                                                          className="ri-file-copy-line cursor-pointer uid_copy_recent"
                                                          onClick={() => {
                                                            handleCopy(
                                                              transaction.transactionId
                                                            );
                                                          }}
                                                        ></i>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                ))
                                            ) : (
                                              <tr>
                                                <td colSpan="5">
                                                  <span className="depo_no_record">
                                                    {t("NoTransactionsFound")}
                                                  </span>
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>

                                        {/* Pagination */}
                                        {totalPagesDp > 1 && (
                                          <div className="pagination history_pagination_all">
                                            <Stack spacing={2}>
                                              <Pagination
                                                count={totalPagesDp}
                                                page={currentPageDp}
                                                onChange={(e, value) =>
                                                  handlePageChange(
                                                    e,
                                                    value,
                                                    "Deposit"
                                                  )
                                                }
                                                size="small"
                                                sx={{
                                                  "& .MuiPaginationItem-root": {
                                                    color: "#fff",
                                                  },
                                                  "& .Mui-selected": {
                                                    backgroundColor:
                                                      "#ffc630 !important",
                                                    color: "#000",
                                                    "&:hover": {
                                                      backgroundColor:
                                                        "#ffc630",
                                                      color: "#000",
                                                    },
                                                  },
                                                  "& .MuiPaginationItem-ellipsis":
                                                    {
                                                      color: "#fff",
                                                    },
                                                  "& .MuiPaginationItem-icon": {
                                                    color: "#fff",
                                                  },
                                                }}
                                              />
                                            </Stack>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Tab>
                          <Tab
                            eventKey="WithdrawHistory"
                            title={t("Withdraw1")}
                          >
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="secuirty_box">
                                  <div className="secuirty_box_contentsub deposit_contentsub">
                                    <div className="table_section home_recent_table">
                                      <div
                                        className="table_boxcontainer"
                                        style={{ height: "max-content" }}
                                      >
                                        <table>
                                          <thead>
                                            <tr>
                                              <th className="text_left">
                                                {t("Currency")}
                                              </th>
                                              <th>{t("Date&Time")}</th>
                                              <th>{t("Network")}</th>
                                              <th>{t("Amount")}</th>
                                              <th>{t("TransactionID")}</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {loader ? (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                    padding: "20px",
                                                  }}
                                                >
                                                  <div className="loader_main loader_mainChange">
                                                    <ScaleLoader
                                                      color="#20A1FD"
                                                      height={10}
                                                      width={3}
                                                    />
                                                    <p>{t("Loading")}</p>
                                                  </div>
                                                </td>
                                              </tr>
                                            ) : withdrawalHistory.length > 0 ? (
                                              withdrawalHistory.map(
                                                (withdrawal, index) => (
                                                  <tr key={index}>
                                                    <td className="table-flex">
                                                      <div className="home_recent_firstdata">
                                                        <img
                                                          src={require("../assests/usdt-logo.png")}
                                                          alt="usdt"
                                                          className="usdt_home_recent"
                                                        />
                                                        <span>
                                                          {withdrawal.currency}
                                                        </span>
                                                      </div>
                                                    </td>
                                                    <td>
                                                      {isNaN(
                                                        new Date(
                                                          withdrawal.date
                                                        )
                                                      )
                                                        ? "null"
                                                        : dayjs(
                                                            withdrawal.date
                                                          ).format(
                                                            "DD MMMM YYYY, hh:mm A"
                                                          )}
                                                    </td>
                                                    <td className="table-flex">
                                                      {withdrawal.network}
                                                    </td>
                                                    <td>{withdrawal.amount}</td>
                                                    <td>
                                                      <div className="home_uid_main">
                                                        <span>
                                                          {withdrawal.txID &&
                                                          withdrawal.txID !==
                                                            "Pending"
                                                            ? truncateText(
                                                                withdrawal?.txID,
                                                                10
                                                              )
                                                            : withdrawal.transactionId &&
                                                              withdrawal.transactionId !==
                                                                "Pending"
                                                            ? truncateText(
                                                                withdrawal?.transactionId,
                                                                10
                                                              )
                                                            : "-"}
                                                        </span>
                                                        {(withdrawal.txID &&
                                                          withdrawal.txID !==
                                                            "Pending") ||
                                                        (withdrawal.transactionId &&
                                                          withdrawal.transactionId !==
                                                            "Pending") ? (
                                                          <i
                                                            className="ri-file-copy-line cursor-pointer uid_copy_recent"
                                                            onClick={() =>
                                                              handleCopy(
                                                                withdrawal.txID ||
                                                                  withdrawal.transactionId
                                                              )
                                                            }
                                                          ></i>
                                                        ) : null}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                )
                                              )
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <span className="depo_no_record">
                                                    {t("NoWithdrawalFound")}
                                                  </span>
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                        {totalPagesWd > 1 && (
                                          <div className="pagination history_pagination_all ">
                                            <Stack spacing={2}>
                                              <Pagination
                                                count={totalPagesWd}
                                                page={currentPageWd}
                                                onChange={(e, value) =>
                                                  handlePageChange(
                                                    e,
                                                    value,
                                                    "Withdraw"
                                                  )
                                                }
                                                size="small"
                                                sx={{
                                                  "& .MuiPaginationItem-root": {
                                                    color: "#fff",
                                                  },
                                                  "& .Mui-selected": {
                                                    backgroundColor:
                                                      "#ffc630 !important",
                                                    color: "#000",
                                                    "&:hover": {
                                                      backgroundColor:
                                                        "#ffc630",
                                                      color: "#000",
                                                    },
                                                  },
                                                  "& .MuiPaginationItem-ellipsis":
                                                    {
                                                      color: "#fff",
                                                    },
                                                  "& .MuiPaginationItem-icon": {
                                                    color: "#fff",
                                                  },
                                                }}
                                              />
                                            </Stack>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Tab>
                          <Tab eventKey="CollectiveSharing" title={t("Profit")}>
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="secuirty_box">
                                  <div className="secuirty_box_contentsub deposit_contentsub">
                                    <div className="table_section home_recent_table">
                                      <div className="table_boxcontainer">
                                        <table>
                                          <thead>
                                            <tr>
                                              <th>{t("RewardAmount")}</th>
                                              <th>{t("Date&Time")}</th>
                                              <th>{t("Type")}</th>
                                              <th>{t("Tier Type")}</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {loader ? (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                    padding: "20px",
                                                  }}
                                                >
                                                  <div className="loader_main loader_mainChange">
                                                    <ScaleLoader
                                                      color="#20A1FD"
                                                      height={10}
                                                      width={3}
                                                    />
                                                    <p>{t("Loading")}</p>
                                                  </div>
                                                </td>
                                              </tr>
                                            ) : getpool.length > 0 ? (
                                              getpool.map((pool, index) => (
                                                <tr key={index}>
                                                  <td className="table-flex">
                                                    <span>
                                                      {pool.rewardAmount}
                                                    </span>
                                                  </td>
                                                  <td>
                                                    {" "}
                                                    <span>
                                                      {isNaN(
                                                        new Date(pool.createdAt)
                                                      )
                                                        ? "null"
                                                        : dayjs(
                                                            pool.createdAt
                                                          ).format(
                                                            "DD MMMM YYYY, hh:mm A"
                                                          )}
                                                    </span>
                                                  </td>
                                                  <td>
                                                    {" "}
                                                    <span>
                                                      {pool.type || "N/A"}
                                                    </span>
                                                  </td>
                                                  <td>
                                                    <span>
                                                      {pool.tierType || "N/A"}
                                                    </span>
                                                  </td>
                                                </tr>
                                              ))
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <span className="depo_no_record">
                                                    {t("NoProfit")}
                                                  </span>
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                        {totalPagesCp > 1 && (
                                          <div className="pagination history_pagination_all ">
                                            <Stack spacing={2}>
                                              <Pagination
                                                count={totalPagesCp}
                                                page={currentPageCp}
                                                onChange={(e, value) =>
                                                  handlePageChange(
                                                    e,
                                                    value,
                                                    "Collective Sharing"
                                                  )
                                                }
                                                size="small"
                                                sx={{
                                                  "& .MuiPaginationItem-root": {
                                                    color: "#fff",
                                                  },
                                                  "& .Mui-selected": {
                                                    backgroundColor:
                                                      "#ffc630 !important",
                                                    color: "#000",
                                                    "&:hover": {
                                                      backgroundColor:
                                                        "#ffc630",
                                                      color: "#000",
                                                    },
                                                  },
                                                  "& .MuiPaginationItem-ellipsis":
                                                    {
                                                      color: "#fff",
                                                    },
                                                  "& .MuiPaginationItem-icon": {
                                                    color: "#fff",
                                                  },
                                                }}
                                              />
                                            </Stack>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Tab>
                          <Tab eventKey="Referal" title={t("Referral")}>
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="secuirty_box">
                                  <div className="secuirty_box_contentsub deposit_contentsub">
                                    <div className="table_section home_recent_table">
                                      <div className="table_boxcontainer">
                                        <table>
                                          <thead>
                                            <tr>
                                              <th>{t("SI.no")}</th>
                                              <th>{t("UserName")}</th>
                                              <th>{t("Date&Time")}</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {loader ? (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                    padding: "20px",
                                                  }}
                                                >
                                                  <div className="loader_main loader_mainChange">
                                                    <ScaleLoader
                                                      color="#20A1FD"
                                                      height={10}
                                                      width={3}
                                                    />
                                                    <p>{t("Loading")}</p>
                                                  </div>
                                                </td>
                                              </tr>
                                            ) : referralHistory.length > 0 ? (
                                              referralHistory.map(
                                                (referral, index) => (
                                                  <tr key={referral.uuid}>
                                                    <td>
                                                      <span>{index + 1}</span>
                                                    </td>
                                                    <td>
                                                      <span>
                                                        {referral.displayname}
                                                      </span>
                                                    </td>
                                                    <td className="">
                                                      <span>
                                                        {new Date(
                                                          referral.createdAt
                                                        ).toLocaleString()}
                                                      </span>
                                                    </td>
                                                  </tr>
                                                )
                                              )
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <span className="depo_no_record">
                                                    {t("ReferralHistory")}
                                                  </span>
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                        {totalPagesRef > 1 && (
                                          <div className="pagination history_pagination_all ">
                                            <Stack spacing={2}>
                                              <Pagination
                                                count={totalPagesRef}
                                                page={currentPageRef}
                                                onChange={(e, value) =>
                                                  handlePageChange(
                                                    e,
                                                    value,
                                                    "Referral"
                                                  )
                                                }
                                                size="small"
                                                sx={{
                                                  "& .MuiPaginationItem-root": {
                                                    color: "#fff",
                                                  },
                                                  "& .Mui-selected": {
                                                    backgroundColor:
                                                      "#ffc630 !important",
                                                    color: "#000",
                                                    "&:hover": {
                                                      backgroundColor:
                                                        "#ffc630",
                                                      color: "#000",
                                                    },
                                                  },
                                                  "& .MuiPaginationItem-ellipsis":
                                                    {
                                                      color: "#fff",
                                                    },
                                                  "& .MuiPaginationItem-icon": {
                                                    color: "#fff",
                                                  },
                                                }}
                                              />
                                            </Stack>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Tab>
                          <Tab eventKey="support" title={t("Support")}>
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="secuirty_box">
                                  <div className="secuirty_box_contentsub deposit_contentsub">
                                    <div className="table_section home_recent_table">
                                      <div
                                        className="table_boxcontainer"
                                        style={{ height: "max-content" }}
                                      >
                                        <table>
                                          <thead>
                                            <tr>
                                              <th>{t("TicketID")}</th>
                                              <th>{t("Date&Time")}</th>
                                              <th>{t("Subject")}</th>
                                              <th>{t("Category")}</th>
                                              <th>{t("Status")}</th>
                                              <th>{t("Action")}</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {loader ? (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                    padding: "20px",
                                                  }}
                                                >
                                                  <div className="loader_main loader_mainChange">
                                                    <ScaleLoader
                                                      color="#20A1FD"
                                                      height={10}
                                                      width={3}
                                                    />
                                                    <p>{t("Loading")}</p>
                                                  </div>
                                                </td>
                                              </tr>
                                            ) : supportHistory.length > 0 ? (
                                              supportHistory.map((ticket) => (
                                                <tr key={ticket._id}>
                                                  <td className="table-flex">
                                                    {ticket._id.slice(0, 10)}
                                                  </td>
                                                  <td>{ticket.created_at}</td>
                                                  <td className="table-flex">
                                                    {truncateText(
                                                      ticket.subject,
                                                      15
                                                    )}
                                                  </td>
                                                  <td>{ticket.category}</td>
                                                  <td>
                                                    {ticket.status === "0"
                                                      ? "Open"
                                                      : "Closed"}
                                                  </td>
                                                  <td>
                                                    <button
                                                      class="action_btn"
                                                      onClick={() =>
                                                        handleOpen(ticket)
                                                      }
                                                    >
                                                      {t("View")}
                                                    </button>
                                                  </td>
                                                </tr>
                                              ))
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <span className="depo_no_record">
                                                    {t("NoSupportTicketsFound")}
                                                  </span>
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                        {totalPagesSp > 1 && (
                                          <div className="pagination history_pagination_all">
                                            <Stack spacing={2}>
                                              <Pagination
                                                count={totalPagesSp}
                                                page={currentPageSp}
                                                onChange={(e, value) =>
                                                  handlePageChange(
                                                    e,
                                                    value,
                                                    "Support"
                                                  )
                                                }
                                                size="small"
                                                sx={{
                                                  "& .MuiPaginationItem-root": {
                                                    color: "#fff",
                                                  },
                                                  "& .Mui-selected": {
                                                    backgroundColor:
                                                      "#ffc630 !important",
                                                    color: "#000",
                                                    "&:hover": {
                                                      backgroundColor:
                                                        "#ffc630",
                                                      color: "#000",
                                                    },
                                                  },
                                                  "& .MuiPaginationItem-ellipsis":
                                                    {
                                                      color: "#fff",
                                                    },
                                                  "& .MuiPaginationItem-icon": {
                                                    color: "#fff",
                                                  },
                                                }}
                                              />
                                            </Stack>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Tab>

                          <Tab
                            eventKey="withdrawadd"
                            title={t("WithdrawAddress")}
                          >
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="secuirty_box">
                                  <div className="secuirty_box_contentsub deposit_contentsub">
                                    <div className="table_section home_recent_table">
                                      <div
                                        className="table_boxcontainer"
                                        style={{ height: "max-content" }}
                                      >
                                        <table>
                                          <thead>
                                            <tr>
                                              <th>{t("Label")}</th>
                                              <th>{t("Address")}</th>
                                              <th>{t("Currency")}</th>
                                              <th>{t("Network")}</th>
                                              <th>{t("Action")}</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {loader ? (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                    padding: "20px",
                                                  }}
                                                >
                                                  <div className="loader_main loader_mainChange">
                                                    <ScaleLoader
                                                      color="#20A1FD"
                                                      height={10}
                                                      width={3}
                                                    />
                                                    <p>{t("Loading")}</p>
                                                  </div>
                                                </td>
                                              </tr>
                                            ) : withdrawaddress.filter(
                                                (address) => !address.isDeleted
                                              ).length > 0 ? (
                                              withdrawaddress
                                                .filter(
                                                  (address) =>
                                                    !address.isDeleted
                                                ) // Filtering out the deleted addresses
                                                .map((ticket) => (
                                                  <tr key={ticket._id}>
                                                    <td>{ticket.label}</td>
                                                    <td>
                                                      {truncateText(
                                                        ticket?.address,
                                                        30
                                                      )}
                                                    </td>
                                                    <td>{ticket.token}</td>
                                                    <td>{ticket.network}</td>
                                                    <td>
                                                      <button
                                                        className="delete-icon-button"
                                                        onClick={() =>
                                                          handleSoftDelete(
                                                            ticket._id
                                                          )
                                                        }
                                                      >
                                                        <i
                                                          className="fa fa-trash"
                                                          aria-hidden="true"
                                                        ></i>
                                                      </button>
                                                    </td>
                                                  </tr>
                                                ))
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <span className="depo_no_record">
                                                    {t("NoWithdrawAddress ")}
                                                  </span>
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                        {totalPageswithadd > 1 && (
                                          <div className="pagination history_pagination_all">
                                            <Stack spacing={2}>
                                              <Pagination
                                                count={totalPageswithadd}
                                                page={currentPagewithadd}
                                                onChange={(e, value) =>
                                                  handlePageChange(
                                                    e,
                                                    value,
                                                    "Withdraw Address"
                                                  )
                                                }
                                                size="small"
                                                sx={{
                                                  "& .MuiPaginationItem-root": {
                                                    color: "#fff",
                                                  },
                                                  "& .Mui-selected": {
                                                    backgroundColor:
                                                      "#ffc630 !important",
                                                    color: "#000",
                                                    "&:hover": {
                                                      backgroundColor:
                                                        "#ffc630",
                                                      color: "#000",
                                                    },
                                                  },
                                                  "& .MuiPaginationItem-ellipsis":
                                                    {
                                                      color: "#fff",
                                                    },
                                                  "& .MuiPaginationItem-icon": {
                                                    color: "#fff",
                                                  },
                                                }}
                                              />
                                            </Stack>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Tab>

                          <Tab eventKey="bot_trade" title={t("BotTrade")}>
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="secuirty_box">
                                  <div className="secuirty_box_contentsub deposit_contentsub">
                                    <div className="table_section home_recent_table">
                                      <div
                                        className="table_boxcontainer"
                                        style={{ height: "max-content" }}
                                      >
                                        <table>
                                          <thead>
                                            <tr>
                                              <th>{t("Exchange")}</th>
                                              <th>{t("Currency")}</th>
                                              <th>{t("Profit")}</th>
                                              <th>{t("Date&Time")}</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {loader ? (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                    padding: "20px",
                                                  }}
                                                >
                                                  <div className="loader_main loader_mainChange">
                                                    <ScaleLoader
                                                      color="#20A1FD"
                                                      height={10}
                                                      width={3}
                                                    />
                                                    <p>{t("Loading")}</p>
                                                  </div>
                                                </td>
                                              </tr>
                                            ) : bottradeHistory.length > 0 ? (
                                              bottradeHistory.map((ticket) => (
                                                <tr key={ticket._id}>
                                                  <td>{ticket.exchange}</td>
                                                  <td>{ticket.currency}</td>
                                                  <td>{ticket.userProfit}</td>
                                                  <td>
                                                    {new Date(
                                                      ticket.createdDate
                                                    ).toLocaleString()}
                                                  </td>
                                                </tr>
                                              ))
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <span className="depo_no_record">
                                                    {t("NoBot")}
                                                  </span>
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                        {totalPagesbtrade > 1 && (
                                          <div className="pagination history_pagination_all">
                                            <Stack spacing={2}>
                                              <Pagination
                                                count={totalPagesbtrade}
                                                page={currentPagebtrade}
                                                onChange={(e, value) =>
                                                  handlePageChange(
                                                    e,
                                                    value,
                                                    "Bot Trade"
                                                  )
                                                }
                                                size="small"
                                                sx={{
                                                  "& .MuiPaginationItem-root": {
                                                    color: "#fff",
                                                  },
                                                  "& .Mui-selected": {
                                                    backgroundColor:
                                                      "#ffc630 !important",
                                                    color: "#000",
                                                    "&:hover": {
                                                      backgroundColor:
                                                        "#ffc630",
                                                      color: "#000",
                                                    },
                                                  },
                                                  "& .MuiPaginationItem-ellipsis":
                                                    {
                                                      color: "#fff",
                                                    },
                                                  "& .MuiPaginationItem-icon": {
                                                    color: "#fff",
                                                  },
                                                }}
                                              />
                                            </Stack>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Tab>

                          <Tab eventKey="plan_histrory" title={t("Plans")}>
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="secuirty_box">
                                  <div className="secuirty_box_contentsub deposit_contentsub">
                                    <div className="table_section home_recent_table">
                                      <div
                                        className="table_boxcontainer"
                                        style={{ height: "max-content" }}
                                      >
                                        <table>
                                          <thead>
                                            <tr>
                                              <th>{t("SubscriptionName")}</th>
                                              <th>
                                                {t("SubscriptionCurrency")}
                                              </th>
                                              <th>{t("Status")}</th>
                                              <th>{t("Date&Time")}</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {loader ? (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                    padding: "20px",
                                                  }}
                                                >
                                                  <div className="loader_main loader_mainChange">
                                                    <ScaleLoader
                                                      color="#20A1FD"
                                                      height={10}
                                                      width={3}
                                                    />
                                                    <p>{t("Loading")}</p>
                                                  </div>
                                                </td>
                                              </tr>
                                            ) : planHistory.length > 0 ? (
                                              planHistory.map((plans) => (
                                                <tr key={plans._id}>
                                                  <td>
                                                    {plans.subscriptionName}
                                                  </td>
                                                  <td>
                                                    {plans.subscriptionCurrency}
                                                  </td>
                                                  <td>
                                                    {plans.isActive == true
                                                      ? "Active"
                                                      : "Deactive"}
                                                  </td>
                                                  <td>
                                                    {new Date(
                                                      plans.createdAt
                                                    ).toLocaleString()}
                                                  </td>
                                                </tr>
                                              ))
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <span className="depo_no_record">
                                                    {t("NoPlansFound")}
                                                  </span>
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                        {totalPagesplans > 1 && (
                                          <div className="pagination history_pagination_all">
                                            <Stack spacing={2}>
                                              <Pagination
                                                count={totalPagesplans}
                                                page={currentPageplans}
                                                onChange={(e, value) =>
                                                  handlePageChange(
                                                    e,
                                                    value,
                                                    "Plans"
                                                  )
                                                }
                                                size="small"
                                                sx={{
                                                  "& .MuiPaginationItem-root": {
                                                    color: "#fff",
                                                  },
                                                  "& .Mui-selected": {
                                                    backgroundColor:
                                                      "#ffc630 !important",
                                                    color: "#000",
                                                    "&:hover": {
                                                      backgroundColor:
                                                        "#ffc630",
                                                      color: "#000",
                                                    },
                                                  },
                                                  "& .MuiPaginationItem-ellipsis":
                                                    {
                                                      color: "#fff",
                                                    },
                                                  "& .MuiPaginationItem-icon": {
                                                    color: "#fff",
                                                  },
                                                }}
                                              />
                                            </Stack>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Tab>

                          <Tab
                            eventKey="adreward_histrory"
                            title={t("Rewards")}
                          >
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="secuirty_box">
                                  <div className="secuirty_box_contentsub deposit_contentsub">
                                    <div className="table_section home_recent_table">
                                      <div
                                        className="table_boxcontainer"
                                        style={{ height: "max-content" }}
                                      >
                                        <table>
                                          <thead>
                                            <tr>
                                              <th>{t("Currency")}</th>
                                              <th>{t("RewardAmount")}</th>
                                              <th>{t("Message")}</th>
                                              <th>{t("Date&Time")}</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {loader ? (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                    padding: "20px",
                                                  }}
                                                >
                                                  <div className="loader_main loader_mainChange">
                                                    <ScaleLoader
                                                      color="#20A1FD"
                                                      height={10}
                                                      width={3}
                                                    />
                                                    <p>{t("Loading")}</p>
                                                  </div>
                                                </td>
                                              </tr>
                                            ) : adminrewadHistory.length > 0 ? (
                                              adminrewadHistory.map((plans) => (
                                                <tr key={plans._id}>
                                                  <td>
                                                    {plans.currencySymbol}
                                                  </td>
                                                  <td>{plans.amount}</td>
                                                  <td>{plans.message}</td>
                                                  <td>
                                                    {new Date(
                                                      plans.date
                                                    ).toLocaleString()}
                                                  </td>
                                                </tr>
                                              ))
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <span className="depo_no_record">
                                                    {t("NoRewardsFound")}
                                                  </span>
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                        {totalPagesadrew > 1 && (
                                          <div className="pagination history_pagination_all">
                                            <Stack spacing={2}>
                                              <Pagination
                                                count={totalPagesadrew}
                                                page={currentPageadrew}
                                                onChange={(e, value) =>
                                                  handlePageChange(
                                                    e,
                                                    value,
                                                    "Rewards"
                                                  )
                                                }
                                                size="small"
                                                sx={{
                                                  "& .MuiPaginationItem-root": {
                                                    color: "#fff",
                                                  },
                                                  "& .Mui-selected": {
                                                    backgroundColor:
                                                      "#ffc630 !important",
                                                    color: "#000",
                                                    "&:hover": {
                                                      backgroundColor:
                                                        "#ffc630",
                                                      color: "#000",
                                                    },
                                                  },
                                                  "& .MuiPaginationItem-ellipsis":
                                                    {
                                                      color: "#fff",
                                                    },
                                                  "& .MuiPaginationItem-icon": {
                                                    color: "#fff",
                                                  },
                                                }}
                                              />
                                            </Stack>
                                          </div>
                                        )}

                                        <Modal
                                          open={open}
                                          onClose={handleClose}
                                          aria-labelledby="modal-modal-title"
                                          aria-describedby="modal-modal-description"
                                        >
                                          <Box
                                            sx={style}
                                            className="modals_support"
                                          >
                                            <div className="container">
                                              <div className="row">
                                                <div className="col-lg-12 support-modal">
                                                  <div>
                                                    <div className="support-left-flex">
                                                      <h5 className="support-modal-title">
                                                        {t("Details")}
                                                      </h5>
                                                      <i
                                                        className="fa-regular fa-circle-xmark cross_circle"
                                                        onClick={handleClose}
                                                      ></i>
                                                    </div>

                                                    <div className="">
                                                      <div className="support-modal-top">
                                                        <h6 className="">
                                                          {t("TicketID")}
                                                        </h6>
                                                        <p className="">
                                                          {supportdata?._id
                                                            ? supportdata._id.slice(
                                                                0,
                                                                10
                                                              )
                                                            : ""}
                                                        </p>
                                                      </div>

                                                      <div className="support-modal-top">
                                                        <h6 className="">
                                                          {t("Subject")}
                                                        </h6>
                                                        <p className="">
                                                          {supportdata?.subject ||
                                                            "N/A"}
                                                        </p>
                                                      </div>

                                                      <div className="support-modal-top">
                                                        <h6 className="">
                                                          {t("Message")}
                                                        </h6>
                                                        <p>
                                                          {supportdata?.message ||
                                                            "N/A"}
                                                        </p>
                                                      </div>

                                                      <div className="support-modal-top">
                                                        <h6 className="">
                                                          {t("Category")}
                                                        </h6>
                                                        <p className="">
                                                          {supportdata?.category ||
                                                            "N/A"}
                                                        </p>
                                                      </div>

                                                      <div className="support-modal-top">
                                                        <h6 className="">
                                                          {t("Date&Time")}
                                                        </h6>
                                                        <p className="">
                                                          {supportdata?.created_at
                                                            ? supportdata.created_at
                                                            : "N/A"}
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </Box>
                                        </Modal>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Tab>
                          <Tab
                            eventKey="notify_history"
                            title={t("Notification")}
                          >
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="secuirty_box">
                                  <div className="secuirty_box_contentsub deposit_contentsub">
                                    <div className="table_section home_recent_table">
                                      <div
                                        className="table_boxcontainer"
                                        style={{ height: "max-content" }}
                                      >
                                        <table>
                                          <thead>
                                            <tr>
                                              <th>{t("Notification")}</th>
                                              <th>{t("Date&Time")}</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {loader ? (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                    padding: "20px",
                                                  }}
                                                >
                                                  <div className="loader_main loader_mainChange">
                                                    <ScaleLoader
                                                      color="#20A1FD"
                                                      height={10}
                                                      width={3}
                                                    />
                                                    <p>{t("Loading")}</p>
                                                  </div>
                                                </td>
                                              </tr>
                                            ) : NotifyHistory.length > 0 ? (
                                              NotifyHistory.map((notify) => (
                                                <tr key={notify._id}>
                                                  <td>{notify.message}</td>
                                                  <td>
                                                    {new Date(
                                                      notify.createdTime
                                                    ).toLocaleString()}
                                                  </td>
                                                </tr>
                                              ))
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <span className="depo_no_record">
                                                    {t("NoNotificationFound")}
                                                  </span>
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                        {notifytotalPages > 1 && (
                                          <div className="pagination history_pagination_all">
                                            <Stack spacing={2}>
                                              <Pagination
                                                count={notifytotalPages}
                                                page={notifycurrentPage}
                                                onChange={(e, value) =>
                                                  handlePageChange(
                                                    e,
                                                    value,
                                                    "notification"
                                                  )
                                                }
                                                size="small"
                                                sx={{
                                                  "& .MuiPaginationItem-root": {
                                                    color: "#fff",
                                                  },
                                                  "& .Mui-selected": {
                                                    backgroundColor:
                                                      "#ffc630 !important",
                                                    color: "#000",
                                                    "&:hover": {
                                                      backgroundColor:
                                                        "#ffc630",
                                                      color: "#000",
                                                    },
                                                  },
                                                  "& .MuiPaginationItem-ellipsis":
                                                    {
                                                      color: "#fff",
                                                    },
                                                  "& .MuiPaginationItem-icon": {
                                                    color: "#fff",
                                                  },
                                                }}
                                              />
                                            </Stack>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Tab>
                          <Tab
                            eventKey="buy_crypto"
                            // title={t("Notification")}
                            title="Buy Crypto"
                          >
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="secuirty_box">
                                  <div className="secuirty_box_contentsub deposit_contentsub">
                                    <div className="table_section home_recent_table">
                                      <div
                                        className="table_boxcontainer"
                                        style={{ height: "max-content" }}
                                      >
                                        <table>
                                          <thead>
                                            <tr>
                                              <th>Crypto / Fiat</th>
                                              <th>Amount</th>
                                              <th>Payment</th>
                                              <th>Status</th>
                                              <th>Date & Time</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {loader ? (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                    padding: "20px",
                                                  }}
                                                >
                                                  <div className="loader_main loader_mainChange">
                                                    <ScaleLoader
                                                      color="#20A1FD"
                                                      height={10}
                                                      width={3}
                                                    />
                                                    <p>Loading</p>
                                                  </div>
                                                </td>
                                              </tr>
                                            ) : buycryptoHistory.length > 0 ? (
                                              buycryptoHistory.map((item) => (
                                                <tr key={item.id}>
                                                  <td>
                                                    {item.cryptoCurrency} /{" "}
                                                    {item.fiatCurrency}
                                                  </td>
                                                  <td>
                                                    {Number(
                                                      item.cryptoAmount
                                                    ).toFixed(4)}
                                                    ({item.fiatAmount}{" "}
                                                    {item.fiatCurrency})
                                                  </td>
                                                  <td>
                                                    {item.paymentOptionId}
                                                  </td>
                                                  <td>{item.status}</td>
                                                  <td>
                                                    {new Date(
                                                      item.createdDate
                                                    ).toLocaleString()}
                                                  </td>
                                                </tr>
                                              ))
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <span className="depo_no_record">
                                                    No Buy Crypto Records Found
                                                  </span>
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>

                                        {buycrypttotalPages > 1 && (
                                          <div className="pagination history_pagination_all">
                                            <Stack spacing={2}>
                                              <Pagination
                                                count={buycrypttotalPages}
                                                page={buycryptcurrentPage}
                                                onChange={(e, value) => {
                                                  setbuycryptCurrentPage(value);
                                                }}
                                                size="small"
                                                sx={{
                                                  "& .MuiPaginationItem-root": {
                                                    color: "#fff",
                                                  },
                                                  "& .Mui-selected": {
                                                    backgroundColor:
                                                      "#ffc630 !important",
                                                    color: "#000",
                                                    "&:hover": {
                                                      backgroundColor:
                                                        "#ffc630",
                                                      color: "#000",
                                                    },
                                                  },
                                                  "& .MuiPaginationItem-ellipsis":
                                                    {
                                                      color: "#fff",
                                                    },
                                                  "& .MuiPaginationItem-icon": {
                                                    color: "#fff",
                                                  },
                                                }}
                                              />
                                            </Stack>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Tab>
                        </Tabs>
                      </>
                    </>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HistoryAll;
